import axios from "axios";
import { HttpInterceptors } from "./interceptors";

const axiosInstance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

function configureInterceptor() {
  HttpInterceptors.forEach((handler) => {
    if (handler.request) {
      const requestInterceptor = handler.request();
      axiosInstance.interceptors.request.use(
        requestInterceptor.onFulfilled,
        requestInterceptor.onRejected,
      );
    }
    if (handler.response) {
      const responseInterceptor = handler.response();
      axiosInstance.interceptors.response.use(
        responseInterceptor.onFulfilled,
        responseInterceptor.onRejected,
      );
    }
  });
}

configureInterceptor();

export default axiosInstance;
